import { ajaxPostJson, setParams, ajaxGetJson } from './ajax';
//分页获取记忆库列表
export const getMemory = (params) => {
  params.filter = setParams(params.filter)
  return ajaxPostJson(`/memory/queryPage`, params, 'BaseApi');
};
// 轮询状态 获取列表表格的 sendCount
export const querySentCount = (params) => {
  return ajaxPostJson(`/memory/querySentCount`, params, 'BaseApi');
};
//获取语言方向
// export const languageDirections = (params) => {
//     return ajaxPostJson(`/memory/queryLangDescList`, params,'BaseApi');
// };
export const languageDirections = (params) => {
  return ajaxPostJson(`/memory/queryLangDescAndCodeList`, params, 'BaseApi');
};
//获取领域
export const getTerritory = (params) => {
  return ajaxPostJson(`/memory/queryDomainList`, params, 'BaseApi');
};
//获取创建记忆库的语言
export const getLang = (params) => {
  return ajaxPostJson(`/common/queryLangList`, params, 'BaseApi');
};
//获取创建记忆库的领域
export const getOptionList = (params) => {
  return ajaxPostJson(`/common/queryOptionList`, params, 'BaseApi');
};
//新增记忆库
export const addMemory = (params) => {
  params.dataType = 'trans_domain'
  return ajaxPostJson(`/memory/addTransMemoryLib`, params, 'BaseApi');
};
//新增术语库
export const addTransTerm = (params) => {
  params.dataType = 'trans_domain'
  return ajaxPostJson(`/term/addTransTermLib`, params, 'BaseApi');
};
//编辑记忆库
export const uploadMemory = (params) => {
  return ajaxPostJson(`/memory/updateTransMemoryLib`, params, 'BaseApi');
};
// 分页查询记忆库明细
export const queryPage = (params) => {
  return ajaxPostJson(`/memorySent/queryPage`, params, 'BaseApi');
};
// 分页查询术语库明细
export const queryPageTermSent = (params) => {
  return ajaxPostJson(`/termSent/queryPage`, params, 'BaseApi');
};
// 添加记忆库明细
export const addSent = (params) => {
  return ajaxPostJson(`/memorySent/addSent`, params, 'BaseApi');
};
// 添加术语库明细
export const addTermSent = (params) => {
  return ajaxPostJson(`/termSent/addSent`, params, 'BaseApi');
};
// 批量删除记忆库明细
export const batchDeleteByIdList = (params) => {
  return ajaxPostJson(`/memorySent/privateBatchDeleteByIdList`, params, 'BaseApi');
};
// 批量删除术语库明细
export const batchDeleteByTermSentIdList = (params) => {
  return ajaxPostJson(`/termSent/privateBatchDeleteByIdList`, params, 'BaseApi');
};
//删除记忆库
export const delMemory = (params) => {
  return ajaxPostJson(`/memory/deleteTransMemoryLib`, params, 'BaseApi');
};
//合并记忆库
export const mergeMemory = (params) => {
  return ajaxPostJson(`/memory/mergeTransMemoryLib`, params, 'BaseApi');
};
//记忆库编辑
export const updateMemoryBank = (params) => {
  return ajaxPostJson(`/memorySent/update`, params, 'BaseApi');
};
//术语库编辑
export const updateTermBank = (params) => {
  return ajaxPostJson(`/termSent/privateUpdate`, params, 'BaseApi');
};
//私有版合并记忆库
export const mergeMemorys = (params) => {
  return ajaxPostJson(`/memory/privatisationMergeTransMemoryLib`, params, 'BaseApi');
};
//记忆库一键入库
export const memorySentPutInStorage = (params) => {
  return ajaxPostJson(`/memorySent/memorySentPutInStorage`, params, 'BaseApi');
};
//术语库一键入库
export const termSentPutInStorage = (params) => {
  return ajaxPostJson(`/term/termSentPutInStorage`, params, 'BaseApi');
};
//记忆库详情修改句子
export const updateMemoryBanks = (params) => {
  return ajaxPostJson(`/memorySent/updateSent`, params, 'BaseApi');
};
// 术语库库详情修改句子
// export const updateTermBanks = (params) => {
//   return ajaxPostJson(`/memorySent/updateSent`, params, 'BaseApi');
// };

// api/v1/memory/queryMemoryInfo   api/v1/term/queryTermInfo

/* 1.4.1 */
// 获取语料库详情
export const getMemoryDetail = (params) => {
  return ajaxPostJson(`/memory/queryMemoryInfo`, params, 'BaseApi');
};
export const getTermDetail = (params) => {
  return ajaxPostJson(`/term/queryTermInfo`, params, 'BaseApi');
};

// 检索
export const getSearchResult = (params) => {
  return ajaxPostJson(`/search/searchCorpus`, params, 'BaseApi');
};
//记忆库一键去重
export const memoryRemoveDeduplication = (params) => {
  return ajaxPostJson(`/memory/memoryRemoveDeduplication`, params, 'BaseApi');
};
//去重轮训接口
export const getRemoveDeduplicationResult = (params) => {
  return ajaxGetJson(`/memory/getRemoveDeduplicationResult?taskKey=${params.taskKey}`, params, 'BaseApi');
};
//去重中止
export const memoryBreakDistinct = (params) => {
  return ajaxPostJson(`/memory/memoryBreakDistinct`, params, 'BaseApi');
};
//获取原文相同 译文不同的数据
export const memoryDeduplication = (params) => {
  return ajaxPostJson(`/memory/memoryDeduplication`, params, 'BaseApi');
};
//记忆库手动去重
export const DeleteByIdList = (params) => {
  return ajaxPostJson(`/memorySent/batchDeleteByIdList`, params, 'BaseApi');
};

/* feature1.4.3  cat1.6*/
// 记忆库整体入库
export const memoryPutInStorage = (params) => {
  return ajaxPostJson(`/memorySent/memoryPutInStorage`, params, 'BaseApi');
};